import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-blue-900 to-teal-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* À Propos */}
          <div>
            <div className="mb-6">
              <img 
                src="https://static.readdy.ai/image/0d2750f7d6b5e2f93012988b5b90ef5f/25af5da9e7bb60657981414c6af3553e.jpeg" 
                alt="Clé Visa" 
                className="h-16 w-auto object-contain brightness-0 invert"
              />
            </div>
            <p className="text-white/80 text-sm leading-relaxed mb-4">
              Votre partenaire de confiance pour tous vos projets de visa et d'immigration. Expertise, professionnalisme et accompagnement personnalisé.
            </p>
            <div className="flex space-x-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-white/10 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-white/10 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-white/10 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-white/10 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-white/10 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-tiktok-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Services Rapides */}
          <div>
            <h3 className="text-lg font-bold mb-6">Services Populaires</h3>
            <ul className="space-y-3">
              <li><a href="#services" className="text-white/80 hover:text-teal-300 transition-colors text-sm cursor-pointer">Conseil & Orientation Visa</a></li>
              <li><a href="#services" className="text-white/80 hover:text-teal-300 transition-colors text-sm cursor-pointer">Constitution de Dossier</a></li>
              <li><a href="#services" className="text-white/80 hover:text-teal-300 transition-colors text-sm cursor-pointer">Vérification de Dossier</a></li>
              <li><a href="#services" className="text-white/80 hover:text-teal-300 transition-colors text-sm cursor-pointer">Préparation Entretien</a></li>
              <li><a href="#services" className="text-white/80 hover:text-teal-300 transition-colors text-sm cursor-pointer">Accompagnement Étudiant</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-6">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-teal-300 mt-1"></i>
                <span className="text-white/80 text-sm">Lomé, Hedzranawoe<br />(ancien OTR), Togo</span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-whatsapp-line text-teal-300"></i>
                <a href="https://wa.me/22892620409" className="text-white/80 hover:text-teal-300 transition-colors text-sm cursor-pointer">+228 92 62 04 09</a>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-mail-line text-teal-300"></i>
                <a href="mailto:clevisa22@gmail.com" className="text-white/80 hover:text-teal-300 transition-colors text-sm cursor-pointer">clevisa22@gmail.com</a>
              </li>
            </ul>
          </div>

          {/* Horaires */}
          <div>
            <h3 className="text-lg font-bold mb-6">Horaires d'Ouverture</h3>
            <ul className="space-y-3">
              <li className="flex justify-between text-sm">
                <span className="text-white/80">Lundi - Vendredi</span>
                <span className="text-teal-300 font-semibold">8h - 18h</span>
              </li>
              <li className="flex justify-between text-sm">
                <span className="text-white/80">Samedi</span>
                <span className="text-teal-300 font-semibold">9h - 14h</span>
              </li>
              <li className="flex justify-between text-sm">
                <span className="text-white/80">Dimanche</span>
                <span className="text-red-300 font-semibold">Fermé</span>
              </li>
            </ul>
            <div className="mt-6 p-4 bg-white/10 rounded-lg">
              <p className="text-xs text-white/80">
                <i className="ri-information-line text-teal-300 mr-2"></i>
                Consultations sur rendez-vous disponibles
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-white/60 text-sm text-center md:text-left">
            © 2024 Clé Visa. Tous droits réservés.
          </p>
          <div className="flex items-center space-x-6">
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-teal-300 text-sm transition-colors cursor-pointer">Powered by Readdy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
